export default "__VITE_ASSET__BdypQG6y__"